import { render, staticRenderFns } from "./SelectPublicationType.vue?vue&type=template&id=d0654e2c&scoped=true"
import script from "./SelectPublicationType.vue?vue&type=script&lang=js"
export * from "./SelectPublicationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0654e2c",
  null
  
)

export default component.exports